<span class="fs-14px text-color-gray-9 sp-mr-10" *featureToggleDisabled="'check-ins-ux-improvements'">{{ "reflections_cadence_compare_button" | localize }}</span>

<ng-container *featureToggleEnabled="'check-ins-ux-improvements'">
  <span class="fs-14px text-color-gray-9 sp-mr-10 desktop">{{ "reflections_cadence_compare_button" | localize }}</span>
  <span class="fs-14px text-color-gray-9 sp-mr-10 mobile">{{ "compare" | localize }}</span>
</ng-container>
<ui-toggle [ngModel]="isComparing" (ngModelChange)="toggleStatus()"></ui-toggle>
